import offerApi from '../api/offer';

// Actions
export const LOAD_OFFERS = 'loadOffers';
export const LOAD_PAST_OFFERS = 'loadPastOffers';
export const REMOVE_OFFER = 'removeOffer';
export const ADD_PAST_OFFER = 'addPastOffer';

const SET_LOADING_OFFERS = 'setLoadingOffers';
const SET_LOADING_PAST_OFFERS = 'setLoadingPastOffers';
const SET_OFFERS = 'setOffers';
const SET_PAST_OFFERS = 'setPastOffers';
const SET_PROCESSING_OFFER = 'setProcessingOffer';

export const offers = {
  state: {
    offers: [],
    pastOffers: null,
    loadingOffers: false,
    loadingPastOffers: false,
    processingOffer: false,
  },
  actions: {
    async loadOffers({ commit }) {
      commit(SET_LOADING_OFFERS, true);

      const offers = await offerApi.getOffers();
      if (offers) {
        commit(SET_OFFERS, offers);
        commit(SET_LOADING_OFFERS, false);
      } else {
        commit(SET_LOADING_OFFERS, false);
      }
    },
    async loadPastOffers({ commit }, page) {
      commit(SET_LOADING_PAST_OFFERS, true);

      const pastOffers = await offerApi.getPastOffers(page);

      commit(SET_PAST_OFFERS, pastOffers);
      commit(SET_LOADING_PAST_OFFERS, false);
    },
    removeOffer({ commit }, offer) {
      commit(REMOVE_OFFER, offer);
      commit(ADD_PAST_OFFER, offer)
    }
  },
  mutations: {
    setOffers(state, offers) {
      state.offers = offers;
    },
    setLoadingOffers(state, status) {
      state.loadingOffers = status;
    },
    setPastOffers(state, pastOffers) {
      state.pastOffers = pastOffers;
    },
    setLoadingPastOffers(state, status) {
      state.loadingPastOffers = status;
    },
    setProcessingOffer(state, status) {
      state.processingOffer = status;
    },
    removeOffer(state, removedOffer) {
      state.offers = [...state.offers].filter(offer => offer.id !== removedOffer.id);
    },
    addPastOffer(state, pastOffer) {
      state.pastOffers = [...state.pastOffers];
      state.pastOffers.push(pastOffer);
    }
  },
  getters: {
    offers(state) {
      return state.offers;
    },
    pastOffers(state) {
      return state.pastOffers;
    },
    loadingOffers(state) {
      return state.loadingOffers;
    },
    loadingPastOffers(state) {
      return state.loadingPastOffers;
    },
    getProcessingOffer(state) {
      return state.processingOffer;
    }
  }
}
